export enum ServiceType {
    Platform = "platform",
    Website = "website",
    App = "app",
}
